import { render, staticRenderFns } from "./HorizantalBarTrendWidget.vue?vue&type=template&id=20924fe1"
import script from "./HorizantalBarTrendWidget.vue?vue&type=script&lang=js"
export * from "./HorizantalBarTrendWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports